import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import * as devicesApi from '../api/devices.api'
import { handleMutationError } from '@kolab/dms-base/lib'
import { QUERY_KEYS, STALE_TIME } from '../utils/constants'

export function useDevice(id: string) {
  return useQuery({
    queryKey: QUERY_KEYS.device(id),
    queryFn: () => devicesApi.getById(id),
    staleTime: STALE_TIME.devices,
    enabled: !!id,
  })
}

export function useDeleteDevice() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => devicesApi.deleteDevice(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.devices })
    },
    onError: (error: unknown) => {
      handleMutationError(error, 'Failed to delete device')
    },
  })
}
